<!--  -->
<template>
<div class='' style="height:90%;">
  <el-button style="margin-bottom:10px" @click="addAdminData()" type="success" icon="el-icon-plus" plain>添加管理员</el-button>
  <el-table
        :data="tableData.list"
        :row-class-name="ifDeleted"
        style="width: 100%;height:85%;overflow: scroll;">
        <el-table-column
           prop="name"
          label="管理员姓名"
          width="180">
        </el-table-column>
        <el-table-column
           prop="username"
          label="管理员账号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="forbidden"
          label="是否禁用"
          :filters="[{text:'禁用',value:true},{text:'正常',value:false}]"
          :filter-method="filterForbidden"
          width="180">
          <template slot-scope="scope">
             <el-switch
              :value="scope.row.forbidden"
              :disabled="scope.row.deleted==1"
              @change="changeForbidden(scope.$index,scope.row)"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="发布时间"
          sortable
          width="180">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.deleted==0">
              <el-button
              size="mini"
              style="margin-right:10px"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
             <el-popconfirm
              confirm-button-text='确定'
              cancel-button-text='不用了'
              icon="el-icon-info"
              icon-color="red"
              @confirm="handleDelete(scope.$index, scope.row)"
              title="确定删除吗？">
              <el-button
              size="mini"
              type="danger"
              slot="reference">删除</el-button>
             </el-popconfirm>
            </div>
            <div v-else>
              <el-tag type="danger">已删除</el-tag>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:10px"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="tableData.totalCount"
        :page-size="tableData.pageSize">
      </el-pagination>
      <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="40%">
        <el-form ref="adminForm" :rules="adminData" :model="form">
          <el-form-item style="display:none">
          <el-input v-model="form.id" clearable></el-input>
          </el-form-item>
          <el-form-item label="管理员姓名" label-width="120px" prop="name">
            <el-input
                placeholder="请输入管理员姓名"
                v-model="form.name"
                clearable>
              </el-input>
          </el-form-item>
          <el-form-item label="管理员账号" label-width="120px" prop="username">
            <el-input
                placeholder="请输入管理员账号"
                v-model="form.username"
                clearable>
              </el-input>
          </el-form-item>
          <el-form-item label="管理员密码" label-width="120px" prop="userpassword">
            <el-input
                show-password
                placeholder="请输入管理员密码"
                v-model="form.password"
                clearable>
              </el-input>
          </el-form-item>
          <el-form-item label="是否禁用" label-width="120px">
            <el-switch
              v-model="form.forbidden"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitAdminData('adminForm')">确 定</el-button>
        </div>
      </el-dialog>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {query,insert,update,queryList,deleted} from '@/api/admin/admin.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  dialogFormVisible:false,
  form:{
    id:"",
    name:"",
    username:"",
    password:"",
    forbidden:false
  },
  tableData:{
    list:[]
  },
  adminData:{
    name:{require:true,message:"管理员姓名不能为空",trigger:'blur'},
    username:{require:true,message:"管理员账号不能为空",trigger:'blur'},
    password:{require:true,message:"管理员密码不能为空",trigger:'blur'}
  },
  condition:{
      current:1,
      size:12,
      title:""
    },
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  ifDeleted({row}){
    if(row.deleted==1){
      return "deleted"
    }
  },
  handleCurrentChange(val){
  var _this =this
  _this.condition.current = val
  queryList(_this.condition).then(({data})=>{
    _this.tableData=data
  })
  },
  handleDelete(index){
    var _this = this
    deleted(_this.tableData.list[index]).then(()=>{
      if((_this.tableData.totalCount%_this.condition.size==1)&&_this.tableData.totalCount!=1&&_this.condition.current==_this.tableData.totalPage){
        _this.condition.current=_this.condition.current-1
      }
      _this.$message.success("删除成功!")
      queryList(_this.condition).then(({data})=>{
        _this.tableData=data
      },()=>{_this.tableData.list=[]})
    })
  },
  handleEdit(index, row){
    var _this = this
    this.dialogFormVisible=true
    query({id:row.id}).then(({data})=>{
      _this.form = data
    })
  },
  submitAdminData(name){
    var _this = this
    this.$refs[name].validate((valid)=>{
      if(valid){
        if(this.form.id==""||this.form.id==undefined||this.form.id==null){
          insert(_this.form).then(()=>{
            _this.dialogFormVisible=false
            _this.$message.success("添加成功")
            queryList(_this.condition).then(({data})=>{
              _this.tableData=data
            })
          })
        }else{
           update(_this.form).then(()=>{
            _this.$message.success("修改成功")
            queryList(_this.condition).then(({data})=>{
              _this.tableData = data
            })
           })
        }
      }else{
        this.$message.info("请根据错误提示填写完整信息")
      }
    })
  },
  addAdminData(){
    this.dialogFormVisible=true
    this.form={id:"",name:"",username:"",password:"",forbidden:false}
  },
  changeForbidden(index,row){
    var _this = this
    update({id:row.id,forbidden:!row.forbidden}).then(()=>{
      _this.$message.success("更新成功!")
    })
   this.tableData.list[index].forbidden=!this.tableData.list[index].forbidden
  },
  filterForbidden(value,row){
    return row.forbidden == value
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  var _this = this
  queryList(_this.condition).then(({data})=>{
              _this.tableData = data
  })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
.el-table .deleted{
  // background-color: rgb(212, 207, 207);
}
</style>